import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ fontWeights, fontSizes, breakpoints, palette }: Theme) => ({
  container: {
    backgroundColor: palette.grey[200],
    padding: '1rem 1.5rem',
    margin: '0 -1.5rem',
    [breakpoints.up('md')]: {
      padding: '1.5rem 3rem',
      margin: '0 -3rem',
    },
  },

  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: fontSizes.sm,
    fontWeight: fontWeights.regular,
    '& p': {
      margin: 0,
    },
  },

  value: {
    fontWeight: fontWeights.medium,
  },

  discount: {
    color: palette.secondary.main,
  },

  pointsLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    margin: 0,
  },

  pointsTooltip: {
    width: '12.9375rem',
    minHeight: '6rem',
    padding: '1rem',
    borderRadius: '0.5rem',
    opacity: 1,
  },

  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '0.75rem',
    fontSize: fontSizes.lg,
    fontWeight: fontWeights.medium,
    '& p': {
      margin: 0,
    },
  },
}));

